import { css } from "@emotion/react";
import { styled, theme } from "../../theme";
export const FloatingFieldLabel = styled.div `
  color: #a8b6ca;
  font-size: 1em;
  font-weight: ${theme.fontWeight.bold};
  opacity: 0;
  transform: translateY(15px);
  transition: transform 250ms;
  ${({ visible }) => visible &&
    css `
      opacity: 1;
      transform: translateY(5px);
    `}
  ${({ uppercase }) => uppercase &&
    css `
      text-transform: uppercase;
    `}
`;
FloatingFieldLabel.defaultProps = {
    uppercase: true,
};
